module.exports = __webpack_public_path__ + "static/media/icon_schedule_message_white.85b452d6.svg";